import { Button, Center, Checkbox, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TSensitiveDataParametersDataTableData = {
  primaryKey: string | number,
  logField: string,
  logFieldTitle: string,
  logSourceTable: string,
  logKeyField: string,
  logKeyFieldDesc: string,
  [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper =
  createColumnHelper<TSensitiveDataParametersDataTableData>();

export function getSensitiveDataParametersDataTableColumns({
  isLoading,
  handleEdit,
}: Props) {
  return [
    columnHelper.accessor('logField', {
      id: 'logField',
      header: 'Log Field',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('logFieldTitle', {
      id: 'logFieldTitle',
      header: 'Log Field Title',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('logSourceTable', {
      id: 'logSourceTable',
      header: 'Log Source Table',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('logKeyField', {
      id: 'logKeyField',
      header: 'Log Key Field',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('logKeyFieldDesc', {
      id: 'logKeyFieldDesc',
      header: 'Log Key Field Desc',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <Button
                size={'sm'}
                onClick={() => handleEdit(props.row)}
                mr={'1rem'}
              >
                Editer
              </Button>
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}
